"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeCollabationTypeChip = ChallengeCollabationTypeChip;
exports.challengeCollaborationTypesMap = void 0;
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const challengeCollaborationTypesMap = exports.challengeCollaborationTypesMap = {
  global: {
    borderColor: '#B38FFF',
    bgColor: '#EAE2FC',
    color: '#743AEF',
    labelKey: 'commons.challenges.competition_types.global_label',
    Icon: _icons.PeopleIcon
  },
  individual: {
    borderColor: '#86D1F1',
    bgColor: '#E7F4FA',
    color: '#1589BB',
    labelKey: 'commons.challenges.competition_types.individual_label',
    Icon: _icons.PersonIcon
  },
  teams: {
    borderColor: '#F390BF',
    bgColor: '#FAE3EE',
    color: '#DA3A87',
    labelKey: 'commons.challenges.competition_types.teams_label',
    Icon: _icons.FlagIcon
  },
  sites: {
    borderColor: '#FFE27D',
    bgColor: '#FFF5D0',
    color: '#BB8A1A',
    labelKey: 'commons.challenges.competition_types.sites_label',
    Icon: _icons.CompanyIcon
  },
  local: {
    borderColor: '#FFB48B',
    bgColor: '#FFEEE0',
    color: '#E06621',
    labelKey: 'commons.challenges.competition_types.local_label',
    Icon: _icons.TargetIcon
  }
};
function ChallengeCollabationTypeChip({
  collaborationType,
  variant
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, collaborationType ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    alignSelf: "flex-start",
    bgcolor: collaborationType?.bgColor,
    borderColor: collaborationType?.borderColor,
    borderRadius: variant === 'top-left-corner' ? '16px 0 16px 0' : 1,
    color: collaborationType?.color,
    display: "flex",
    gap: 1,
    paddingX: 1,
    paddingY: 0.5,
    sx: {
      borderStyle: 'solid',
      borderWidth: variant === 'top-left-corner' ? '0 1px 1px 0' : 1
    }
  }, /*#__PURE__*/_react.default.createElement(collaborationType.Icon, {
    color: "inherit",
    fontWeight: 600,
    sx: {
      height: 16,
      width: 16
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "inherit",
    fontWeight: 600,
    lineHeight: 1,
    variant: "body2"
  }, t(collaborationType.labelKey))) : collaborationType === undefined && /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 26,
    variant: "rounded",
    width: 200
  }));
}